export const usePageTransition = () => {
    const startFade = (onComplete) => {
        // onComplete se ejecuta cuando termina la animación
        const ev = new CustomEvent("app:pageFadeOut", { detail: { onComplete } });
        window.dispatchEvent(ev);
    };
    return { startFade };
};
